import styled from 'styled-components';

const Header = styled.div`
    display: flex;
    flex-direction: row;
    margin: 20px 10px;
    height: 50px;
    justify-content: center;
    align-items: center;
`

export default Header